import { action, makeObservable, observable } from 'mobx';

class KeypadStore {

  text: string = '';
  opened: boolean = false;
  onSave: ((number: number) => void) | null = null;

  constructor() {
    makeObservable(this, {
      text: observable,
      opened: observable,
      setText: action,
      setOpened: action,
    })
  }

  setText = (text: string) => {
    this.text = text;
  }

  setOpened = (opened: boolean, onSave?: (number: number) => void) => {
    this.opened = opened;
    if (onSave) {
      this.onSave = onSave;
    }
  }

}

export const keypadStore = new KeypadStore();
